'use client';

import { AuthenticationProvider } from '@/components/auth/authentication';
import { AnalyticsProvider } from '@/components/providers/analytics-provider';
import { ConfigurationsProvider } from '@/components/providers/configurations-provider';
import { FeatureFlagsProvider } from '@/components/providers/feature-flag-provider';
import { LayoutProvider } from '@/components/providers/layout-provider';
import QueryProvider from '@/components/providers/query-provider';
import { SharedStateProvider } from '@/components/providers/shared-state-provider';
import { TheaterProvider } from '@/components/providers/theater-provider';
import { ThemeProvider } from '@/components/providers/theme-provider';
import { Configurations } from '@/types/configurations';
import { FeatureFlags } from '@/types/feature-flags';
import { SharedState } from '@/types/shared-state';
import { SessionProvider } from 'next-auth/react';

type ProvidersProps = {
  analyticsScriptSrc: string;
  children: React.ReactNode;
  config: Configurations;
  initialFeatureFlags: FeatureFlags;
  initialHideLayout: boolean;
  initialSharedState: SharedState;
  mobileBearerToken?: string;
};

export const Providers = ({
  analyticsScriptSrc,
  children,
  config,
  initialFeatureFlags,
  initialHideLayout,
  initialSharedState,
  mobileBearerToken,
}: Readonly<ProvidersProps>): React.JSX.Element => {
  return (
    <SessionProvider basePath={'/papi/auth'}>
      <QueryProvider>
        <AnalyticsProvider analyticsScriptSrc={analyticsScriptSrc} />
        <ConfigurationsProvider config={config} />
        <FeatureFlagsProvider initialFeatureFlags={initialFeatureFlags} />
        <LayoutProvider initialHideLayout={initialHideLayout} />
        <SharedStateProvider initialSharedState={initialSharedState} />
        <TheaterProvider />
        <ThemeProvider>
          <AuthenticationProvider mobileBearerToken={mobileBearerToken}>
            {children}
          </AuthenticationProvider>
        </ThemeProvider>
      </QueryProvider>
    </SessionProvider>
  );
};
